var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlanning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 20.8335H12.6668C12.0557 20.8335 11.5557 21.321 11.5557 21.9168C11.5557 22.5127 12.0557 23.0002 12.6668 23.0002H19.3334C19.9446 23.0002 20.4446 22.5127 20.4446 21.9168C20.4446 21.321 19.9446 20.8335 19.3334 20.8335Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5552 15.4165H10.4441C9.83301 15.4165 9.33301 15.904 9.33301 16.4998C9.33301 17.0957 9.83301 17.5832 10.4441 17.5832H21.5552C22.1663 17.5832 22.6663 17.0957 22.6663 16.4998C22.6663 15.904 22.1663 15.4165 21.5552 15.4165Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11111 12.1667H24.8889C25.5 12.1667 26 11.6792 26 11.0833C26 10.4875 25.5 10 24.8889 10H7.11111C6.5 10 6 10.4875 6 11.0833C6 11.6792 6.5 12.1667 7.11111 12.1667Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlanning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/planning.69839a49.svg";
export { ForwardRef as ReactComponent };